import { Link } from 'react-router-dom';
import EditIcon from '../../../assets/icons/editBlue.svg';
import Delete from '../../../assets/icons/trash.svg';
import ModalContainer from '../../modalContainer';
import EditGroup from '../editGroupModal';
import { useState } from 'react';
import DeleteSchoolModal from '../deleteSchoolModal';
import {deleteSchoolGroup, updateSchoolGroup} from "../../../API/apiService";
import {toast} from "react-toastify";

function SchoolRow({ school ,municipalities,getSchoolsInfo}) {
  const [editModal, setEditModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);


  const year = [
    {
      name: '2015',
      code: '2015',
      value: 1
    },
    {
      name: '2016',
      code: '2016',
      value: 1
    },
    {
      name: '2017',
      code: '2017',
      value: 1
    },
    {
      name: '2018',
      code: '2018',
      value: 1
    },
    {
      name: '2019',
      code: '2019',
      value: 1
    }
  ];
  const sourceType = [
    {
      name: 'Recurso ordinario',
      code: 'RO',
      value: 1
    },
    {
      name: 'Presupuesto participativo',
      code: 'PP',
      value: 2
    }
  ];
  const schoolType = [
    {
      name: 'NNAJ',
      id: 1
    },
    {
      name: 'ADULTOS',
      id: 1
    }
  ];


  async function editGroup(group){
    const updated= await updateSchoolGroup(group);
    if(updated){
      setEditModal(false);
      toast('Grupo Actualizado', {
        type: 'success'
      });
      getSchoolsInfo();
    }

  }

  async function deleteGroup(group, school){
    console.log(group, school);
   const updated= await deleteSchoolGroup(group, school);
    if(updated){
      setEditModal(false);
      toast('Grupo Actualizado', {
        type: 'success'
      });
      getSchoolsInfo();
    }

  }

  return (
    <>
      {editModal && (
        <ModalContainer>
          <EditGroup
            municipalities = {municipalities}
            schoolType={schoolType}
            sourceType={sourceType}
            year={year}
            motherOrganization={sourceType}
            setEditModal={setEditModal}
            school={school}
            editGroup={editGroup}
          />
        </ModalContainer>
      )}
      {deleteModal && (
        <ModalContainer>
          <DeleteSchoolModal school={school} setDeleteModal={setDeleteModal}  deleteGroup={deleteGroup}/>
        </ModalContainer>
      )}
      <div className='info-container'>
        <p className='school-option'>{school?.code}</p>
        <p className='school-option'>{school?.type}</p>
        <p className='school-option'>{school?.groupInfo.code}</p>
        <p className='school-option'>{school?.groupInfo?.user?.full_name??school?.user?.full_name}</p>
        <p className='school-option'>{school?.groupInfo?.municipality?.name??school?.municipality?.name}</p>
        <p className='school-option'>{school?.groupInfo?.neighborhood?.name??school?.neighborhood?.name}</p>
        <p className='school-option'>{school?.resource?.name}</p>
        <p className='school-option'>{school?.groupInfo?.organization??school?.organization}</p>
        <p className='school-option'>{school?.year}</p>
        <div className='school-option icons-container'>
          <button onClick={() => setEditModal(true)} className='button-edit'>
            <span className='tooltiptext'>Editar</span>
            <img src={EditIcon} alt='' />
          </button>
          <button
            onClick={() => setDeleteModal(true)}
            className='button-delete'>
            <span className='tooltiptext'>Eliminar</span>

            <img src={Delete} alt='' />
          </button>

          <Link
            to={`/administrador/menu/escuelas/beneficiarios_inscritos?escuela=${school.name}&group=${school.group}`}
            className='group'>
            <span className='tooltiptext'>Ver</span>
            <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 29.756 19.837'>
              <path
                id='Icon_awesome-eye'
                data-name='Icon awesome-eye'
                d='M29.576,13.664A16.569,16.569,0,0,0,14.878,4.5,16.572,16.572,0,0,0,.18,13.665a1.671,1.671,0,0,0,0,1.508,16.569,16.569,0,0,0,14.7,9.164,16.572,16.572,0,0,0,14.7-9.165A1.671,1.671,0,0,0,29.576,13.664Zm-14.7,8.193a7.439,7.439,0,1,1,7.439-7.439A7.439,7.439,0,0,1,14.878,21.858Zm0-12.4a4.924,4.924,0,0,0-1.308.2,2.472,2.472,0,0,1-3.456,3.456,4.948,4.948,0,1,0,4.764-3.652Z'
                transform='translate(0 -4.5)'
                fill='#00904C'
              />
            </svg>
          </Link>
        </div>
      </div>
    </>
  );
}

export default SchoolRow;